let displayTimezone: string | null = null;

const isKnownTimezone = (timeZone: string): boolean => {
  try {
    Intl.DateTimeFormat(undefined, { timeZone });
    return true;
  } catch {
    return false;
  }
};

/** `null` keeps the browser timezone. Invalid names are ignored. */
export const setDisplayTimezone = (
  timeZone: string | null | undefined,
): void => {
  if (!timeZone || !isKnownTimezone(timeZone)) {
    displayTimezone = null;
    return;
  }
  displayTimezone = timeZone;
};

export const getDisplayTimezone = (): string | null => displayTimezone;

/** Saved IANA zone, or the browser zone when the user has not chosen one. */
export const getActiveTimezoneName = (): string =>
  displayTimezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

/** Google-style offset such as `GMT+1` for the zone a timestamp is shown in. */
export const formatTimezoneOffset = (
  at: Date,
  timeZone: string = getActiveTimezoneName(),
): string => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour: 'numeric',
    timeZoneName: 'shortOffset',
  }).formatToParts(at);
  return parts.find((part) => part.type === 'timeZoneName')?.value ?? 'GMT';
};

/** Zone name plus offset, for the calendar header. */
export const formatTimezoneNotice = (at: Date): string =>
  `${getActiveTimezoneName()} (${formatTimezoneOffset(at)})`;
